/* eslint-disable no-unused-vars */
import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import store from "@/store";
import NProgress from "nprogress";
import appConfig from "@/config.json";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/about/",
    name: "About",
    meta: {
      requiresAuth: true,
    },
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
  {
    path: "/login/",
    name: "Login",
    meta: {
      hideAlert: true,
    },
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/Login.vue"),
  },
  {
    path: "/success/",
    name: "Success",
    meta: {
      hideAlert: true,
    },
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/Success.vue"),
  },
  {
    path: "/logout/",
    name: "Logout",
    meta: {
      hideAlert: true,
    },
    component: () =>
      import(/* webpackChunkName: "logout" */ "../views/Logout.vue"),
  },
  {
    path: "/register/",
    name: "Register",
    meta: {
      hideAlert: true,
    },
    component: () =>
      import(/* webpackChunkName: "register" */ "../views/Register.vue"),
  },
  {
    path: "/forgot/",
    name: "Forgot",
    meta: {
      hideAlert: true,
    },
    component: () =>
      import(/* webpackChunkName: "forgot" */ "../views/Forgot.vue"),
  },
  {
    path: "/web-support/",
    name: "WebSupport",
    meta: {
      hideAlert: true,
      hideScrollButton: true,
    },
    component: () =>
      import(/* webpackChunkName: "support" */ "../views/Forms/webSupport.vue"),
  },
  {
    path: "/reset/",
    name: "Reset",
    meta: {
      hideAlert: true,
      hideScrollButton: true,
    },
    component: () =>
      import(/* webpackChunkName: "reset" */ "../views/Reset.vue"),
  },
  {
    path: "/pages/",
    name: "Pages",
    component: () => import(/* webpackChunkName: "page" */ "../views/Page.vue"),
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: "/pages/:slug/",
    name: "PageSingle",
    component: () =>
      import(/* webpackChunkName: "page" */ "../views/PageSingle.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/news/",
    name: "News",
    component: () => import(/* webpackChunkName: "news" */ "../views/News.vue"),
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: "/news/:slug/",
    name: "NewsSingle",
    component: () =>
      import(/* webpackChunkName: "news" */ "../views/NewsSingle.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/documents/",
    name: "Documents",
    component: () =>
      import(/* webpackChunkName: "documents" */ "../views/Documents.vue"),
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: "/documents/:slug/",
    name: "DocumentsSingle",
    component: () =>
      import(
        /* webpackChunkName: "documents" */ "../views/DocumentsSingle.vue"
      ),
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: "/events/",
    name: "EventCalendar",
    component: () =>
      import(/* webpackChunkName: "calendar" */ "../views/Events.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/events/:slug/",
    name: "EventSingle",
    component: () =>
      import(/* webpackChunkName: "calendar" */ "../views/EventSingle.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/forms/",
    name: "Forms",
    component: () =>
      import(/* webpackChunkName: "forms" */ "../views/Forms/index.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/forms/support/",
    name: "FormSupport",
    component: () =>
      import(/* webpackChunkName: "forms" */ "../views/Forms/support.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/forms/hr/",
    name: "FormHR",
    component: () =>
      import(/* webpackChunkName: "forms" */ "../views/Forms/hr.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/forms/laptop/",
    name: "FormLaptop",
    component: () =>
      import(/* webpackChunkName: "forms" */ "../views/Forms/laptop.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/forms/vehicle/",
    name: "FormVehicleRequest",
    component: () =>
      import(/* webpackChunkName: "forms" */ "../views/Forms/vehicle.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/forms/conference/",
    name: "FormConference",
    component: () =>
      import(/* webpackChunkName: "forms" */ "../views/Forms/conference.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/forms/supplies/",
    name: "FormSupplyRequest",
    component: () =>
      import(/* webpackChunkName: "forms" */ "../views/Forms/supplies.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/search/",
    name: "Search",
    component: () =>
      import(/* webpackChunkName: "search" */ "../views/Search.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/social/facebook/",
    name: "Facebook",
    component: () =>
      import(/* webpackChunkName: "social" */ "../views/SocialFacebook.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/units/",
    name: "UnitPages",
    component: () =>
      import(/* webpackChunkName: "units" */ "../views/Units.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/units/:slug/",
    name: "UnitPageList",
    component: () =>
      import(/* webpackChunkName: "units" */ "../views/UnitSingle.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/tags/",
    name: "TagPages",
    component: () => import(/* webpackChunkName: "tags" */ "../views/Tags.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/tags/:slug/",
    name: "TagPageList",
    component: () =>
      import(/* webpackChunkName: "tags" */ "../views/TagSingle.vue"),
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: "/forms/profile/",
    name: "UserProfile",
    component: () =>
      import(
        /* webpackChunkName: "UserProfile" */ "../views/Forms/profile.vue"
      ),
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: "*",
    name: "FourOhFour",
    component: () => import(/* webpackChunkName: '404' */ "../views/404.vue"),
    meta: {
      hideAlert: true,
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: appConfig.publicPath,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

// console.log(appConfig.underConstruction);

// Check if a JWT is expired by decoding the payload
function isTokenExpired(token) {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    if (!payload.exp) return false;
    return Date.now() >= payload.exp * 1000;
  } catch (e) {
    return true;
  }
}

router.beforeEach((to, from, next) => {
  window.NProgress.start();
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  let jwt = localStorage.getItem("jwt");

  if (requiresAuth) {
    if (!store.state.auth.isAuthenticated || !jwt || isTokenExpired(jwt)) {
      store.dispatch("auth/logout");
      return next({
        path: "/login/",
        query: { redirect: to.fullPath },
      });
    }
  }

  next();
});

router.afterEach((routeTo, routeFrom) => {
  window.NProgress.done();
});

// Recover from stale lazy-loaded route chunks after a deploy. Every build renames
// the per-route JS chunks; a browser tab still running the previous build asks for
// a chunk that no longer exists, so the SPA fallback returns index.html and Vue
// throws a ChunkLoadError / "MIME type 'text/html'" error and the navigation dies.
// Reload once to pick up the current build. A timestamped guard avoids reload
// loops if a chunk is genuinely missing rather than merely stale.
router.onError((error) => {
  const message = (error && error.message) || "";
  const isChunkError = /Loading (?:CSS )?chunk \S+ failed|ChunkLoadError|Failed to fetch dynamically imported|Importing a module script failed|'text\/html'/i.test(
    message
  );
  if (!isChunkError) return;
  try {
    const KEY = "icjia-chunk-reload";
    const last = Number(window.sessionStorage.getItem(KEY) || 0);
    if (Date.now() - last > 10000) {
      window.sessionStorage.setItem(KEY, String(Date.now()));
      window.location.reload();
    }
  } catch (e) {
    window.location.reload();
  }
});

export default router;
